import React, { useState, useEffect} from "react";
import { makeStyles, createMuiTheme, ThemeProvider} from "@material-ui/core/styles";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import axios from "axios";
import Autocomplete from "@material-ui/lab/Autocomplete";
import InputLabel from '@material-ui/core/InputLabel';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import MessageBox from "../../../components/MessageBox/MessageBox";
import { green } from '@material-ui/core/colors';

const useStyles = makeStyles((theme) => ({
	modal: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		width: "100%",
		maxWidth: "800px",
		margin: "0 auto",
	},
	paper: {
		backgroundColor: theme.palette.background.paper,
		border: "2px solid #000",
		boxShadow: theme.shadows[5],
		padding: theme.spacing(2, 4, 3),
		width: "800px",
		maxHeight:"100%",
		overflow: "auto",
	},
	root: {
		"& .MuiTextField-root": {
			width: "100%",
		},
	},
	button: {
		textAlign: "right",
		marginTop: "30px",
		"& .MuiButton-containedPrimary": {
			marginRight: "10px",
		},
	},

	buttonMarginRight: {
		marginRight: "0.5rem",
	},
}));

export default function UpdateContentNav(props) {
	const {mn_details, showModal, mainNav} = props;
	const classes = useStyles();
	const [open, setOpen] = useState(false);
	const [description, setDescription] = useState('');
	const [name, setName] = useState('');

	const [url, setUrl] = useState('');
	const [icon, setIcon] = useState('');

	const [btnDisabled, setBtnDisabled] = useState(true);
	const [arrangement, setArrangement] = useState('');

	//Message Box
	const [showMsgBox, setShowMsgBox] = useState(false);
	const [msgBoxContent, setMsg] = useState("Empty");
	const [msgType, setMsgType] = useState("success");
	//Message Box EOF

	const main_nav_id = mn_details.main_nav_id;
	// let _cn_fkey = cn_details.cn_fkey;

	const setFields = () => {
				setArrangement(mn_details.arrangement);
				setDescription(mn_details.main_nav_desc);
				setUrl(mn_details.main_nav_href);
				setIcon(mn_details.icon);
	};

	const handleOpen = () => {
		// mainNav.some(function(entry, i) {
		// 	if (entry.main_nav_id == _cn_fkey) {
		// 		// console.log(entry.main_nav_id);
		// 		// console.log(res.data.data.cn_fkey);
		// 		console.log(i);
		// 		setPositionIndex(i);
		// 		return true;
		// 	}
		// });
		setOpen(true);
	};

	const handleClose = () => {
		//setPositionIndex(null);
		setOpen(false);
	};


	// const selectMainNavProps = {
	// 	options: mainNav,
	// 	getOptionLabel: (option) => option.main_nav_desc,
	// };


	useEffect(() => { //
		if(open){
			setFields();
		}
	}, [open]);


	useEffect(() => {
		if (url && description && arrangement) {
			setBtnDisabled(false); // re-enable
		} else {
			setBtnDisabled(true); // re-enable
		}
	}, [url,description,arrangement]);

	const saveMainNav = async (position_name, main_nav, content_nav) => {
			const formData = new FormData();
			formData.append("main_nav_id", main_nav_id);
			formData.append("main_nav_href", url);
			formData.append("main_nav_desc", description);
			formData.append("icon", icon);
			formData.append("arrangement", parseFloat(arrangement)); 
	
			await axios.post(process.env.REACT_APP_API_URL+'update_main_nav', formData, {
				headers: {
					'Content-Type': 'multipart/form-data'
					}
				}).then(function(res) {
					showModal('Updated Main Navigation '+ name, 'success');
					handleClose();
				  }).catch(function (error) {
					showModal('Something went wrong '+ error.message, 'warning');
					handleClose();
				  });
	}

	const handleSubmit = (e) => {
		e.preventDefault();
		saveMainNav();
    }


	return (
		<div>
				<Button variant="contained" style={{backgroundColor: "#4caf50", color:"#fff"}} color="primary" onClick={handleOpen}>
					Edit
				</Button>	
			<Modal
				aria-labelledby="transition-modal-title"
				aria-describedby="transition-modal-description"
				className={classes.modal}
				open={open}
				onClose={handleClose}
				closeAfterTransition
				BackdropComponent={Backdrop}
				BackdropProps={{
					timeout: 500,
				}}
			>
				<Fade in={open}>

				<div className={classes.paper}>
						<MessageBox in={showMsgBox} content={msgBoxContent} type={msgType}/>
						<h2 id="transition-modal-title">Edit Main Navigation</h2>
						{open ? (<form onSubmit={handleSubmit} className={classes.root}>
							<Grid container spacing={2}>
								<Grid item xs={12} xl={12}> 
									<TextField id="outlined-basic" label="Description" variant="outlined" style={{marginTop:"21px"}}  placeholder="Description" fullWidth={true} inputProps={{ 'aria-label': 'Description' }} value={description} onChange={e => setDescription(e.target.value)}/>
								</Grid>	
								<Grid item xs={12} xl={12}> 
									<TextField id="outlined-basic" label="URL" variant="outlined"  placeholder="URL" fullWidth={true} inputProps={{ 'aria-label': 'URL' }} value={url} onChange={e => setUrl(e.target.value)}/>
								</Grid>	
								<Grid item xs={12} xl={12}> 
									<TextField id="outlined-basic" label="Icon" variant="outlined"  placeholder="Icon" fullWidth={true} inputProps={{ 'aria-label': 'URL' }} value={icon} onChange={e => setIcon(e.target.value)}/>
								</Grid>	
								<Grid item xs={12} xl={12}> 
									<TextField id="outlined-basic" type="number" label="Arrangement" variant="outlined"  placeholder="Arrangement" fullWidth={true} inputProps={{ 'aria-label': 'Arrangement' }} value={arrangement} onChange={e => setArrangement(e.target.value)}/>
								</Grid>	
							</Grid>
							<div className={classes.button}>
								<Button
									variant="contained"
									onClick={handleClose}
									className={classes.buttonMarginRight}
								>
									Close
								</Button>
								<Button type="submit" disabled={btnDisabled} variant="contained" color="primary">
									Save Main Navigation
								</Button>
							</div>
						</form>) : (<></>)}
					</div>

				</Fade>
			</Modal>
		</div>
	);
}
